import RangeToColorConverterBase from "./RangeToColorConverterBase.js";
import RGBA from '../../valueObjects/RGBA.js';

class LinearRangeToColorConverter extends RangeToColorConverterBase {
    /**
     * Allows to defined linear color scale
     * @param {RGBA} colorFrom - starting color
     * @param {RGBA} colorTo - final color
     * @param {boolean} interpolate - default false, when set to true colors will be assigned to the middle of the range
     */
    constructor(colorFrom, colorTo, interpolate) {
        super();

        if (!(colorFrom instanceof RGBA)) {
            throw new TypeError('colorFrom must be an instance inheriting from RGBA class');
        }

        if (!(colorTo instanceof RGBA)) {
            throw new TypeError('colorTo must be an instance inheriting from RGBA class');
        }

        if (typeof(interpolate) === 'undefined') {
            this.interpolate = false;
        }
        else if (!typeof(interpolate) === 'boolean') {
            throw new TypeError('interpolate must be boolean or undefined');
        }
        else {
            this.interpolate = interpolate;
        }

        this.colorFrom = colorFrom;
        this.colorTo = colorTo;
    }

    getColor(from, to, min, max) {
        const rangeMid = this.interpolate ? (from + to)  / 2: from - min;
        const normalized = Math.abs(rangeMid / (max - min));

        return new RGBA(
            Math.round(this.colorFrom.red + normalized * (this.colorTo.red - this.colorFrom.red)),
            Math.round(this.colorFrom.green + normalized * (this.colorTo.green - this.colorFrom.green)),
            Math.round(this.colorFrom.blue + normalized * (this.colorTo.blue - this.colorFrom.blue)),
            Math.round(this.colorFrom.alpha + normalized * (this.colorTo.alpha - this.colorFrom.alpha))
        );
    }
}

export default LinearRangeToColorConverter;